<template>
  <div
    v-if="!!sessionMaterials || sessionMaterials != []"
    :class="{ 'blocco_sfumato cf cancel-button': !isUsedInsideNewReservedArea }"
  >
    <div v-if="!isRowExpanded">
      <div class="titolo title">Materiale Didattico</div>
      <div
        v-for="(session, index) in sessionMaterials"
        :key="session.sessionId"
      >
        <div class="row-fluid">
          <DxDataGrid
            :ref="dataGridRefKey + index"
            :data-source="session.teachingMaterials"
          >
            <DxPaging :enabled="true"></DxPaging>
            <DxColumn
              alignment="left"
              data-field="dayNumber"
              caption="Giornata"
              :width="150"
            ></DxColumn>
            <DxColumn
              alignment="left"
              data-field="dayName"
              :caption="session.sessionName"
            ></DxColumn>
            <DxColumn
              alignment="center"
              caption="Download"
              data-field="url"
              cell-template="loadButton"
              :width="250"
            ></DxColumn>
            <template #loadButton="{ data }">
              <div>
                <DxButton
                  styling-mode="contained"
                  :text="data.data.isDownload ? 'PDF' : 'Visualizza'"
                  type="default"
                  @click="
                    !isUsedInsideNewReservedArea || data.data.isDownload
                      ? goToCourse(data)
                      : toggleRowContent(data, index)
                  "
                >
                </DxButton>
              </div>
            </template>
            <!-- <DxMasterDetail :enabled="false" template="master-detail" />
            <template #master-detail="{}">
              <div class="employeeInfo">
                <p class="employeeNotes">{{ data.data.dayId }}</p>
              </div>
            </template> -->
          </DxDataGrid>
        </div>
      </div>
    </div>
    <EcClassroomMaterial
      v-if="isUsedInsideNewReservedArea && isRowExpanded"
      :day-id-from-new-reserved-area="classMaterial.dayId"
      :site-id-from-new-reserved-area="classMaterial.siteId"
      :is-used-inside-new-reserved-area="true"
    />
  </div>
</template>
<script>
import { DxButton } from 'devextreme-vue/button'

import { DxDataGrid, DxColumn, DxPaging } from 'devextreme-vue/data-grid'
import EcClassroomMaterial from '@/ec-classroom-material/components/EcClassroomMaterial.vue'

const dataGridRefKey = 'dataGridRefKey'

export default {
  name: 'EcTeachingMaterialsGrid',
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxButton,
    EcClassroomMaterial,
  },
  props: {
    courseIdFromNewReservedArea: {
      type: Number,
      default: -1,
    },
    editionIdFromNewReservedArea: {
      type: Number,
      default: -1,
    },
    subscriptionIdFromNewReservedArea: {
      type: Number,
      default: -1,
    },
    isUsedInsideNewReservedArea: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      courseId: null,
      siteId: null,
      codeId: null,
      sessionMaterials: null,
      dataGridRefKey,
      classMaterial: null,
      isRowExpanded: null,
    }
  },
  created() {
    const teachingMaterialsGrid = document.querySelector(
      '#ec-teaching-materials-grid'
    )
    if (teachingMaterialsGrid) {
      this.courseId = teachingMaterialsGrid.getAttribute('courseId')
      this.siteId = teachingMaterialsGrid.getAttribute('siteId')
      this.codeId = teachingMaterialsGrid.getAttribute('codeId')
    } else {
      this.courseId = this.courseIdFromNewReservedArea
      this.siteId = this.editionIdFromNewReservedArea
      this.codeId = this.subscriptionIdFromNewReservedArea
    }
  },
  mounted() {
    const teachingMaterialsGrid = document.querySelector(
      '#ec-teaching-materials-grid'
    )
    if (teachingMaterialsGrid) {
      this.loadMaterials()
    } else {
      this.loadMaterialsForNewReservedArea()
    }
  },
  methods: {
    goToCourse(data) {
      var url = window.location.origin + '/' + data.data.url
      if (data.data.isDownload) {
        window.open(url, '_blank')
      } else {
        document.location.href = url
      }
    },
    loadMaterials() {
      const codeIdSplitted = this.codeId.split('|')
      const sessionParams = {
        courseId: this.courseId,
        siteId: this.siteId,
        codeId: codeIdSplitted[1],
      }
      this.apiService.trainingProductsApiService
        .getTeachingMaterial(sessionParams)
        .then(res => {
          this.sessionMaterials = res
        })
    },
    loadMaterialsForNewReservedArea() {
      const sessionParams = {
        courseId: this.courseId,
        siteId: this.siteId,
        codeId: this.codeId,
      }
      this.apiService.trainingProductsApiService
        .getTeachingMaterial(sessionParams)
        .then(res => {
          this.sessionMaterials = res
        })
    },
    toggleRowContent(data, index) {
      sessionStorage.setItem('goBackPage', 'classroomMaterial')
      const dataGrid = this.$refs[dataGridRefKey + index][0].instance
      if (dataGrid.isRowExpanded(data.key)) {
        dataGrid.collapseRow(data.key)
        this.isRowExpanded = false
      } else {
        dataGrid.expandRow(data.key)
        this.classMaterial = {
          dayId: data.data.dayId,
          siteId: data.data.siteId,
        }
        this.isRowExpanded = true
      }
    },
  },
}
</script>
<style scoped>
.table-header {
  text-transform: uppercase;
  text-align: left;
  background: #00a0dc;
  color: white;
  padding: 10px;
  font: 14px/14px pt_sansregular;
}
.subelement-headers {
  margin-top: 25px;
}
</style>
